// extracted by mini-css-extract-plugin
export default {"more-content":"MoreContent_more-content__SjcBN"};